export default "__VITE_ASSET__CR6NWhdZ__"